import Router from "@page-containers/locations/locations-router";

export default Router;
